import styled from 'styled-components';
import { getFontSize, getSpacing, getColorAlias } from '../../utils/index.js';

const ProgressBarContainer = styled.div `
  ${getFontSize('size16')};
  font-family: ${(props) => props.theme.font.familyPrimary};
  font-weight: ${(props) => props.theme.font.weightRegular};
  width: 100%;
  border-radius: ${(props) => props.theme.radius.roundedB};
  display: flex;
  flex-direction: column;
  min-width: 250px;
`;
const ProgressBarHeader = styled.div `
  display: flex;
  justify-content: space-between;
  ${getFontSize('size14')};
  margin-bottom: ${getSpacing('s02')};
`;
const LabelText = styled.span `
  font-weight: ${(props) => props.theme.font.weightBold};
  color: ${getColorAlias('contentDefault')};
  align-self: center;
`;
const AltText = styled.span `
  color: ${getColorAlias('contentSubdued')};
  align-self: center;
`;
const ProgressBarEmpty = styled.div `
  width: 100%;
  background: ${getColorAlias('interactiveSecondary')};
  border-radius: ${(props) => props.theme.radius.roundedB};
  height: 6px;
`;
const ProgressBarFiller = styled.div `
  background: ${({ variant }) => variant === 'primary'
    ? getColorAlias('interactiveBrand')
    : getColorAlias('interactivePrimary')};
  width: ${(props) => props.width}%;
  border-radius: ${(props) => props.theme.radius.roundedB};
  height: 6px;
  text-align: center;
  min-width: max-content;
  transition: width ${(props) => props.theme.motion.speed.defaultL};
`;

export { AltText, LabelText, ProgressBarContainer, ProgressBarEmpty, ProgressBarFiller, ProgressBarHeader };
